import { Popover, Button } from "antd";
import React, { useEffect, useState, useRef } from "react";
import CodeEditorInput from "./CodeEditorInput";
import "./CodeEditor.scss";
import { X } from "lucide-react";

interface Props {
  value: string;
  onChange: (value: string) => void;
  title?: string | React.ReactNode;
  language?: string;
  placement?: any;
  align?: any;
  width?: string | number;
  containerClassName?: string;
  height?: string;
  id?: string;
  buttonWidth?: string | number;
}
const CodeEditor = (props: Props) => {
  const {
    value,
    onChange,
    language,
    placement,
    align,
    width,
    containerClassName,
    title,
    id,
    buttonWidth,
  } = props;
  const [visible, setVisible] = useState(false);
  const codeEditorRef = useRef<HTMLDivElement>(null);
  const LANGUAGE_PREVIEW_MAP = {
    css: `/* Custom CSS */`,
    html: `<!-- Custom HTML -->`,
    javascript: `// Custom JavaScript`,
  };
  const languagePreview =
    LANGUAGE_PREVIEW_MAP[language] || "Enter your code here";

  const scrollContainer = () => {
    const codeEditorElement = codeEditorRef.current;
    if (!codeEditorElement) return;
    const container = codeEditorElement.closest(`.${containerClassName}`);
    if (!container) return;
    const containerRect = container.getBoundingClientRect();
    const elementRect = codeEditorElement.getBoundingClientRect();
    const scrollTop = container.scrollTop;
    const elementTopRelativeToContainer =
      elementRect.top - containerRect.top + scrollTop;
    const centeredScrollTop =
      elementTopRelativeToContainer -
      container.clientHeight / 2 +
      elementRect.height / 2;
    container.scrollTop = centeredScrollTop;
  };

  const handleVisibleChange = (visible: boolean) => {
    if (visible) {
      scrollContainer();
    }
    setTimeout(() => {
      setVisible(visible);
    }, 0);
  };

  const handleClose = () => {
    setVisible(false);
  };

  const renderValue = (value) => {
    if (language === "css") {
      return (value || "").toString().replace(/{{id}}/g, `#thisComponent`);
    }
    return value;
  }

  return (
    <div className="code-editor" ref={codeEditorRef} id={id} style={{
      width: buttonWidth || "100%",
    }}>
      <Popover
        transitionName="none"
        overlayClassName="code-editor__popover"
        placement={placement || "topLeft"}
        trigger="click"
        onVisibleChange={handleVisibleChange}
        visible={visible}
        content={
          <div style={{ width: width || 360 }}>
            <CodeEditorInput
              language={language || "html"}
              value={renderValue(value)}
              onChange={onChange}
              defaultValue={renderValue(value)}
              height={props.height || "500"}
            />
          </div>
        }
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>{title}</div>
            <div
              style={{ lineHeight: 0, padding: 4, cursor: "pointer" }}
              onClick={handleClose}
            >
              <X size={16} />
            </div>
          </div>
        }
        align={
          align || {
            offset: [0, 0],
          }
        }
        destroyTooltipOnHide={true}
      >
        <div className="code-editor__button">
          <div
            className="code-editor__button-container"
            // style={{
            //   opacity: value ? 1 : 0.4,
            // }}
          >
            <CodeEditorInput
              language={language || "html"}
              value={renderValue(value)}
              defaultValue={value ? renderValue(value) : languagePreview}
              height="68"
              width="calc(100% + 33px)"
              key={`editor-preview-${value}`}
            />
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default CodeEditor;
